'use client'

import { Button } from '@/core/components/button'
import { UniversalSearchInput } from '@/features/search/components/universal-search-input.client'
import { useSearchIntentNavigation } from '@/features/search/hooks/use-search-intent-navigation'
import type { SearchIntent } from '@/features/search/models/search-intent.model'

/** Three example searches, each landing in the app it belongs to. */
const EXAMPLE_QUERIES: { query: string; intent: SearchIntent }[] = [
  { query: 'Flooring', intent: 'profinder' },
  { query: 'Shampoo', intent: 'shop' },
  { query: 'PaddleSmash', intent: 'shop' },
]

export function LandingHero() {
  const { goToQuery } = useSearchIntentNavigation()
  return (
    <section className="landing-hero-wash">
      <div className="relative z-10 mx-auto flex max-w-5xl flex-col items-center px-5 pb-14 pt-20 text-center sm:pb-16 sm:pt-24 lg:pt-28">
        <p className="text-xs font-bold uppercase tracking-[0.18em] text-primary">Welcome to HubHive</p>
        <div className="mt-5 max-w-4xl">
          <h1 className="text-[34px] font-bold leading-[1.08] text-navy sm:text-5xl lg:text-[57px]">
            <span className="block">Find your people.</span>
            <span className="block">Shop your network.</span>
            <span className="block">Hire with confidence.</span>
          </h1>
          <p className="mx-auto mt-6 max-w-2xl text-base leading-7 text-muted-foreground sm:text-lg">
            Connect in Hives, discover products from people you know, and find pros trusted by your community.
          </p>
        </div>
        <div className="mt-9 w-full max-w-3xl">
          <UniversalSearchInput isPublic variant="hero" />
          <div className="mt-4 flex flex-wrap items-center justify-center gap-2">
            <span className="text-xs text-muted-foreground">Try</span>
            {EXAMPLE_QUERIES.map(({ query, intent }) => (
              <Button
                key={query}
                type="button"
                variant="outline"
                size="sm"
                className="h-8 rounded-full px-3 text-muted-foreground hover:text-primary"
                onClick={() => goToQuery(query, intent)}
              >
                {query}
              </Button>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
